export default __webpack_public_path__ + "static/media/personalization.481eb7cc.svg";